<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">Enroll in PSP</h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a routerLink="/driver/1"
              (click)="scrollToTop()"
              name="Driver-record-request"
              id="Driver-record-request"
              [title]="'Start_8-2' | translator:'base'" 
              class="ms-1" 
           >
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar [step]="18" [totalSteps]="19"></app-complete-bar>
               <h2 *ngIf="!showBilling" [innerHTML]="'CONGRATULATIONS' | translator:'base'">CONGRATULATIONS!</h2>
               <h2 *ngIf="showBilling" [innerHTML]="'billing_Payment Information' | translator:'base'">Payment Information!</h2>
               <div *ngIf="!showBilling">
                 <p>{{ customizeSuccessMessage() }}</p>
                 <hr>
                 <div class="alert alert-warning">
                   <span [innerHTML]="'billing_2' | translator:'base'">
                     Your PSP account must be activated before you can login to PSP. You will receive an email when your account is ready to use.
                   </span>
                 </div>
               </div>
               <div class="actions text-left" *ngIf="showBilling && billingService.walletURL != ''">
                 <iframe [src]="iframeSrc"
                    aria-label="Add Payment Method form with credit card or e-check."
                    id="paymentInformation"
                    name="paymentInformation"
                    role="presentation"
                    scrolling="no" 
                  ></iframe>
               </div>
               <div *ngIf="!showBilling && billingService.walletURL == ''">
                 <h3 [innerHTML]="'billing_3' | translator:'base'">HOW WOULD YOU LIKE TO PAY?</h3>
                 <p [innerHTML]="'billing_3_1' | translator:'base'">Please make a selection to set up an electronic payment option. You will be invoiced monthly.</p>
                 <div class="text-center">
                   <button (click)="showBillingBox()"
                           class="btn btn-primary"
                           [innerHTML]="'billing_4' | translator:'base'"
                           [title]="'billing_4' | translator:'base'"
                           name="set-up-auto-pay"
                           id="set-up-auto-pay"
                    >Set Up Auto Pay
                   </button>
                   <br>
                   <a href="javascript:void(0);"
                      (click)="setupChecking()"
                      class="btn btn-link"
                      [innerHTML]="'billing_5' | translator:'base'"
                      [title]="'billing_5' | translator:'base'"
                      name="pay-by-mail"
                      id="pay-by-mail"
                    >Pay By Mail
                   </a>
                 </div>
               </div>
               <hr>
               <div *ngIf="!showBilling" [innerHTML]="'billing_6' | translator:'base'">If you choose to forgo an electronic payment method, you can pay your monthly invoice each month by sending a check in the mail.</div>
               <div class="overlay" *ngIf="loadingPayment">
                 <h1 class="heading" [innerHTML]="'Loading Payments' | translator:'base'">Loading Payments page.</h1>
                 <img />
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="7"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
   </div>
   
